import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorCodeComponent } from './error-code.component';

@NgModule({
  declarations: [
    ErrorCodeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ErrorCodeComponent
  ]
})
export class ErrorCodeModule { }
